import styled from 'styled-components'
import { Box } from '../../atoms'

export const SectionAnalysisContainer = styled(Box)`
  width: 100%;
  background: ${({ theme }) => theme.colors.background.primary};
  padding-bottom: 60px;
`

export const SectionAnalysisTabsContainer = styled.div`
  display: flex;
  border-bottom: 1px solid ${({ theme }) => theme.colors.border.light};
  margin-bottom: 32px;
  overflow-x: auto;

  @media (max-width: 768px) {
    margin-bottom: 24px;
  }
`

export const SectionAnalysisTabButton = styled.button<{ $active: boolean }>`
  background: none;
  border: none;
  padding: 16px 24px;
  font-size: 14px;
  font-weight: 500;
  color: ${({ theme, $active }) =>
    $active ? theme.colors.primary : theme.colors.text.secondary};
  border-bottom: 2px solid
    ${({ theme, $active }) => ($active ? theme.colors.primary : 'transparent')};
  cursor: pointer;
  transition: all 0.2s ease;
  white-space: nowrap;
  min-width: 120px;

  &:hover {
    color: ${({ theme }) => theme.colors.primary};
    background: ${({ theme }) => theme.colors.background.secondary};
  }

  @media (max-width: 768px) {
    padding: 12px 16px;
    font-size: 13px;
    min-width: 100px;
  }
`

export const SectionAnalysisContentContainer = styled.div`
  width: 100%;
  padding-top: 24px;
`

export const SectionAnalysisLoadingContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 400px;
  color: ${({ theme }) => theme.colors.text.secondary};
`

export const SectionAnalysisErrorContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 400px;
  color: ${({ theme }) => theme.colors.danger};
  text-align: center;
`

export const SectionAnalysisTabContentContainer = styled.div`
  width: 100%;
  padding: 0 24px;

  @media (max-width: 768px) {
    padding: 0 8px;
  }
`
export const AnalysisTabContentContainer = styled.div`
  width: 100%;
  padding: 0 24px 24px 24px;

  @media (max-width: 768px) {
    padding: 0 8px;
  }
`

export const SectionAnalysisMetricsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 24px;
  margin-bottom: 32px;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
    gap: 16px;
    margin-bottom: 24px;
  }
`

export const SectionAnalysisChartGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 32px;
  margin-bottom: 32px;

  @media (max-width: 1200px) {
    grid-template-columns: 1fr;
    gap: 24px;
  }

  @media (max-width: 768px) {
    gap: 16px;
    margin-bottom: 24px;
  }
`

export const SectionAnalysisChartContainer = styled.div`
  background: ${({ theme }) => theme.colors.background.primary};
  border-radius: 12px;
  padding: 24px;
  border: 1px solid ${({ theme }) => theme.colors.border.primary};

  @media (max-width: 768px) {
    padding: 16px;
  }
`

export const SectionAnalysisChartTitle = styled.h3`
  font-size: 18px;
  font-weight: 600;
  color: ${({ theme }) => theme.colors.text.primary};
  margin: 0 0 16px 0;

  @media (max-width: 768px) {
    font-size: 16px;
    margin-bottom: 12px;
  }
`

export const SectionAnalysisChartSubtitle = styled.p`
  font-size: 14px;
  color: ${({ theme }) => theme.colors.text.secondary};
  margin: 0 0 24px 0;
  line-height: 1.4;

  @media (max-width: 768px) {
    font-size: 13px;
    margin-bottom: 16px;
  }
`

export const SectionAnalysisInsightCard = styled.div`
  background: ${({ theme }) => theme.colors.background.tertiary};
  border-radius: 8px;
  padding: 16px;
  border-left: 4px solid ${({ theme }) => theme.colors.primary};
  margin-top: 16px;

  @media (max-width: 768px) {
    padding: 12px;
    margin-top: 12px;
  }
`

export const SectionAnalysisInsightTitle = styled.h4`
  font-size: 14px;
  font-weight: 600;
  color: ${({ theme }) => theme.colors.text.primary};
  margin: 0 0 8px 0;
`

export const SectionAnalysisInsightText = styled.p`
  font-size: 13px;
  color: ${({ theme }) => theme.colors.text.secondary};
  margin: 0;
  line-height: 1.4;
`

export const SectionAnalysisFilterContainer = styled.div`
  display: flex;
  gap: 16px;
  align-items: center;
  margin-bottom: 24px;
  padding: 16px;
  background: ${({ theme }) => theme.colors.background.secondary};
  border-radius: 8px;
  border: 1px solid ${({ theme }) => theme.colors.border.primary};

  @media (max-width: 768px) {
    flex-direction: column;
    align-items: stretch;
    gap: 12px;
    padding: 12px;
  }
`

export const SectionAnalysisFilterLabel = styled.label`
  font-size: 14px;
  font-weight: 500;
  color: ${({ theme }) => theme.colors.text.primary};
  white-space: nowrap;
`

export const SectionAnalysisFilterSelect = styled.select`
  padding: 8px 12px;
  border: 1px solid ${({ theme }) => theme.colors.border.primary};
  border-radius: 6px;
  background: ${({ theme }) => theme.colors.background.primary};
  color: ${({ theme }) => theme.colors.text.primary};
  font-size: 14px;
  cursor: pointer;

  &:focus {
    outline: none;
    border-color: ${({ theme }) => theme.colors.primary};
  }
`

export const SectionAnalysisFilterSection = styled.div`
  display: flex;
  flex-direction: column;
  background: ${({ theme }) => theme.colors.background};
  border-bottom: 1px solid ${({ theme }) => theme.colors.border.light};
  flex-shrink: 0;
  padding: 0px 24px;
`

export const SectionAnalysisFilterBar = styled.div`
  padding: 20px 0px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 24px;
  min-height: 68px;

  @media (max-width: ${({ theme }) => theme.breakpoints.tablet}) {
    flex-direction: column;
    align-items: stretch;
    gap: 16px;
  }
`

export const SectionAnalysisLocationFilters = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  flex: 1;
  flex-wrap: wrap;

  @media (max-width: ${({ theme }) => theme.breakpoints.tablet}) {
    flex-direction: column;
    align-items: stretch;
  }
`

export const SectionAnalysisFilterChip = styled.div<{ $active?: boolean }>`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 6px 14px;
  background: ${({ theme, $active }) =>
    $active ? theme.colors.primary + '20' : theme.colors.background.secondary};
  color: ${({ theme, $active }) =>
    $active ? theme.colors.primary : theme.colors.text.primary};
  border: 1px solid
    ${({ theme, $active }) =>
      $active ? theme.colors.primary : theme.colors.border.light};
  border-radius: 20px;
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
  white-space: nowrap;
  user-select: none;

  &:hover {
    background: ${({ theme, $active }) =>
      $active ? theme.colors.primary + '30' : theme.colors.background.tertiary};
    border-color: ${({ theme, $active }) =>
      $active ? theme.colors.primary : theme.colors.border.default};
    transform: translateY(-1px);
    box-shadow: ${({ theme }) => theme.shadows.sm};
  }

  &:active {
    transform: translateY(0);
  }

  svg {
    width: 14px;
    height: 14px;
  }

  @media (max-width: ${({ theme }) => theme.breakpoints.tablet}) {
    padding: 8px 16px;
    font-size: 14px;
    flex: 1;
    justify-content: center;
  }
`

export const SectionAnalysisLocationBadge = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 4px 10px;
  color: ${({ theme }) => theme.colors.text.primary};
  border-radius: 16px;
  font-size: 12px;
  font-weight: 500;

  svg {
    width: 12px;
    height: 12px;
  }
`

export const SectionAnalysisDivider = styled.div`
  width: 1px;
  height: 16px;
  background: ${({ theme }) => theme.colors.border.light};
`

export const SectionAnalysisAdvancedFiltersToggle = styled.button<{
  $expanded?: boolean
}>`
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 8px 16px;
  background: ${({ theme, $expanded }) =>
    $expanded ? theme.colors.primary : theme.colors.background.primary};
  color: ${({ theme, $expanded }) =>
    $expanded ? theme.colors.text.inverse : theme.colors.text.secondary};
  border: 1px solid
    ${({ theme, $expanded }) =>
      $expanded ? theme.colors.primary : theme.colors.border.default};
  border-radius: 20px;
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
  white-space: nowrap;
  margin-left: auto;

  &:hover {
    border-color: ${({ theme }) => theme.colors.primary};
    color: ${({ theme, $expanded }) =>
      $expanded ? theme.colors.text.inverse : theme.colors.primary};
  }

  svg {
    width: 14px;
    height: 14px;
  }

  @media (max-width: ${({ theme }) => theme.breakpoints.tablet}) {
    padding: 10px 16px;
    font-size: 14px;
  }
`

export const SectionAnalysisAdvancedFiltersPanel = styled.div<{
  $expanded?: boolean
}>`
  display: ${({ $expanded }) => ($expanded ? 'block' : 'none')};
  margin-top: 20px;
  padding: 20px;
  background: ${({ theme }) => theme.colors.background.primary};
  border: 1px solid ${({ theme }) => theme.colors.border.light};
  border-radius: 12px;
  animation: slideDown 0.2s ease-out;

  @keyframes slideDown {
    from {
      opacity: 0;
      transform: translateY(-10px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }
`

export const SectionAnalysisAdvancedFiltersHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 16px;
  padding-bottom: 12px;
  border-bottom: 1px solid ${({ theme }) => theme.colors.border.light};

  .header-title {
    display: flex;
    align-items: center;
    gap: 8px;
    font-size: 14px;
    font-weight: 600;
    color: ${({ theme }) => theme.colors.text.primary};
  }

  svg {
    width: 16px;
    height: 16px;
    color: ${({ theme }) => theme.colors.text.secondary};
  }
`

export const SectionAnalysisAdvancedFilters = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 10px;

  @media (max-width: ${({ theme }) => theme.breakpoints.tablet}) {
    flex-direction: column;
    align-items: stretch;
  }
`
